<template>
  <div class="contactUs" v-on:scroll="handleScroll(event)" style="  overflow: hidden;">
    <div id="title">
        <h1>聯絡我們</h1>
    </div> 
    <div class="container">
        <img src="./../assets/kmap/kmap.png"
            srcset="./../assets/kmap/kmap@2x.png 2x"
            class="kmap">
        <table>
          <tr>
            <td class="title">地址</td>
            <td class="content">嘉義市西區長榮街303號</td>
          </tr>
          <tr>
            <td class="title">預約專線</td>
            <td class="content"><a href="tel:+886-05-2316999">05-2316999</a></td>
          </tr>          
          <tr>
            <td class="title">傳真</td>
            <td class="content"><a href="tel:+886-05-2249611">05-2249611</a></td>
          </tr>  
          <tr>
            <td class="title">客服電話</td>
            <td class="content"><a href="tel:+886-0800-520-919">0800-520-919</a></td>
          </tr>          
          <tr>
            <td class="title">客服信箱</td>
            <td class="content"><a href="mailto:cs@kingstonecy.com.tw">cs@kingstonecy.com.tw</a></td>
          </tr>          
        </table>
      <span id="note"><hr><h2>商業交流歡迎蒞臨指教</h2><hr></span>
    </div>
    <div id="subtitle">
        <h1>歡迎來信</h1>
    </div> 
      <div id="form-content">
          <div class="form-group"><span class="label-group">主旨</span><input class="text-group" type="text" v-model="mail.subject"/></div>
          <div class="form-group"><span class="label-group">姓名</span><input class="text-group" type="text" v-model="mail.name"/></div>
          <div class="form-group"><span class="label-group">Email</span><input class="text-group" type="email" v-model="mail.address"/></div>
          <div class="form-group" style="margin-bottom:0;"><span class="label-group">電話</span><input class="text-group" type="text" v-model="mail.phone"/></div>
          <div class="label-textarea">來信內容</div>             
          <textarea class="content-textarea" v-model="mail.content"></textarea>             

      </div>
      <div id="form-btn">
        <button type="submit" id="submit-btn" @click="sendMail(mail)">確認送出</button>
      </div>
  </div>
  
</template>
<script>
import navlist from './../components/navlist.vue'
export default {
  components:{
    navlist
  },
  data(){
    return {      
      windowscrollY:"",
      className_theLINE:'',
      className_theFIG:'',
      className_theIcon:'',
      className_theFLOW:'',
      mail:{
        subject:'', 
        name:'', 
        address:'', 
        phone:'',
        content:''  },
      }
  },
  methods: {
      handleScroll (event) {
        this.windowscrollY = window.scrollY
        // console.log(this.windowscrollY)
        if (this.windowscrollY > 160) {
            this.className_theLINE = 'theLINE'
            this.className_theFIG = 'theFIG'
            this.className_theIcon = 'theIcon'
            // console.log(this.className+'foo')
        // Any code to be executed when the window is scrolled
      }
      if(this.windowscrollY > 915){
            this.className_theFLOW = 'theFLOW'
      }
      // else console.log('no')
      },
      sendMail(mail) {
        this.address = mail.address
        if(this.address == ''){
          alert("不好意思，請您提供電子郵件信箱！");
        }else{ 
          this.address = mail.address
          this.senddetail(mail)
        }   
   },      
      senddetail(mail) {
        this.subject = mail.subject
        if(this.subject == ''){
          this.subject ='詢問金石建設相關服務事項'
        }else{ 
          this.subject = mail.subject
        }
        this.name = mail.name
        if(this.name == ''){
          this.name = '未提供姓名/公司行號'
        }else{ this.name = mail.name
        }

        this.phone = mail.phone
        if(this.phone == ''){
          this.phone = '未提供電話'
        }else{ 
          this.phone = mail.phone
        }
        this.content = mail.content
        if(mail.content == ''){
          this.content = '請直接來電或來信聯絡，謝謝！'
        }else{ 
          this.content = mail.content
        }
        this.date_year = new Date().getFullYear()
        this.date_month = new Date().getMonth()+ 1
        this.date_day = new Date().getDate()
        
        this.date_time_hour = new Date().getHours()
        if(this.date_time_hour < 10){
          this.date_time_hour = '0'+new Date().getHours()
        }else{
          this.date_time_hour = new Date().getHours()
        }
        this.date_time_minute = new Date().getMinutes()
        if(this.date_time_minute < 10){
          this.date_time_minute = '0'+new Date().getMinutes()
        }else{
          this.date_time_minute = new Date().getMinutes()
        }
        this.date_time_sec =  new Date().getSeconds()
        if(this.date_time_sec < 10){
          this.date_time_sec = '0'+new Date().getSeconds()
        }else{
          this.date_time_sec = new Date().getSeconds()
        }
        this.date_time = this.date_time_hour + ':' + this.date_time_minute + ':' + this.date_time_sec
        this.date_weekday = new Date().getDay()
        if(this.date_weekday == 0){
          this.date_weekday = 'Sun'
        }else if(this.date_weekday == 1){
          this.date_weekday = 'Mon'
        }else if(this.date_weekday == 2){
          this.date_weekday = 'Tue'
        }else if(this.date_weekday == 3){
          this.date_weekday = 'Wed'
        }else if(this.date_weekday == 4){
          this.date_weekday = 'Thu'
        }else if(this.date_weekday == 5){
          this.date_weekday = 'Fri'
        }else if(this.date_weekday == 6){
          this.date_weekday=  'Sat'
        }
        this.date = this.date_year+'-'+this.date_month+'-'+this.date_day+' '+this.date_weekday+' '+this.date_time
        // alert("感謝您的來信，我們會盡快請專人與您聯繫！");
        window.open(
          'mailto:cs@kingstonecy.com.tw?subject='+this.subject+' - ' +this.name + ' (' + this.address + ')'
           + '&body=' + '%0D%0A' +'客戶來信內容/需求：' + '%0D%0A' + this.content + '%0D%0A' + '%0D%0A' + '------------------------- 聯絡方式 -------------------------' + '%0D%0A' + '姓名/公司名稱： ' + this.name + '%0D%0A' + '電子郵件： '+ this.address + '%0D%0A' + '電話：' + this.phone + '%0D%0A' +'----------------------------------------------------------------'+ '%0D%0A' + '%0D%0A' + '%0D%0A' + '煩請您儘速來電/聯絡' + '%0D%0A' + '來信日期：' + this.date, '_blank')         
      }
  },
  created () {
      window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style scoped>
.contactUs{
  width: 100%;
  height: auto;
  margin:70px 0 0 0;
  text-align: center;
}

#title h1{
  width: 100%;
  height: auto;
  padding: 1% 0;
  font-size: 22px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.93px;
  color: #a89a80;
}

.container{
  width: 90%;
  height: auto;
  margin:  5% auto 5% auto;
  /* background-image: linear-gradient(to top, #c4c3c230 41%, #dadad93a 60%, #feffff79 100%); */
}

.kmap{
  width: 90%;
  height: auto;
  margin:  5% auto 5% auto;
}

p{
  margin: 0 auto;
  width: 86%;
  height: 450px;
  font-size: 17.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.22;
  letter-spacing: 1.07px;
  text-align: justify;
  color: #7d7d7d;
}

#subtitle h1{
  width: 100%;
  height: auto;
  margin-top: 15%;
  margin-bottom: 10%;
  padding: 8% 0 4% 0;
  font-size: 22px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.93px;
  color: #a89a80;
}
table{
  width: 88%;
  height: auto;
  margin: 0 auto 10% auto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.14;
  letter-spacing: 1.11px;
  text-align: justify;
  color: #7d7d7d;
}

.title{  width: 20%; }
.content{  width: 70%;}

a[href^="tel:"] {
  color: #7d7d7d;
  text-decoration: none;
}
a[href^="tel:"]:before {
  content: "\260E";
  margin-right: 0.5em;
}
a[href^="mailto:"] {
  color: #7d7d7d;
  text-decoration: none;
}
a[href^="mailto:"]:before {
  content: "\1F4EE";
  filter:grayscale(1) brightness(1.9) contrast(0.8);
  /* content:"\1F4E9"; */
  margin: 0 0.3em 0 -0.1em;
}

#note{
  width: 88%;
  height: auto;
  margin: 0 auto;
}
#note h2{
  width: 48%;
  height:30px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.5;
  letter-spacing: 0.95px;
  text-align: justify;
  color: #7d7d7d;
  margin: 0 auto;
  text-align: center;
  display: inline-block;
}
#note hr{
  width: 50px;
  height: 0;
  border: solid 0.5px #979797;
  margin: 1% 3%;
  vertical-align:text;
  display: inline-block;
}
#form-content{   
  text-align: center;
  width: 85%;
  margin: 5% auto 15% auto; 
}

.form-group{
  display: block;
  height: 42px;
  margin: 20px 0; 
  border-bottom: solid 1px #bbbbbb;
}
.label-group {
  float: left;
  margin: 0 auto;
  padding: 1px;
  width: 20%;
  height: 40px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.14;
  letter-spacing: 1.11px;
  text-align: left;
  vertical-align: middle;
  color: #7d7d7d;
}
.text-group{
  margin: -23% auto 0 6%;
  width: 74%;
  height: auto;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  font-size: 14px;
  line-height: 2.14;
  letter-spacing: 1.11px;
  text-align: left;
  vertical-align: middle;
  color: #7d7d7d;
  background: transparent;
  /* border: solid 1px #7d7d7d; */
  border: none;
  overflow: auto;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  resize: none;   
}
.label-textarea {
  float: left;
  margin: 20px auto 0 auto;
  height: 40px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.14;
  letter-spacing: 1.11px;
  text-align: left;
  color: #7d7d7d;
}
.content-textarea{
  width: 93%;
  height: 257px;
  margin: 0 auto;
  padding: 0 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  font-size: 14px;
  line-height: 2.14;
  letter-spacing: 1.11px;
  text-align: left;
  color: #7d7d7d;
  border: #bbbbbb 1px solid;
  overflow: auto;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  resize: none; 
}
#form-btn{   
  text-align: center;
  width: 100%;
  margin: 7% 0 15% 0;
}
#submit-btn{ 
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: 1.27px;
  text-align: justify;
  color: #d0ad76;
  padding: 10px 17px 10px 18px;
  border: solid 1px #d0ad76;
  background: transparent;
}
#submit-btn:hover, #submit-btn:active {
  color: #ffffff;
  background: #ddc59f;
  border: solid 1px #ddc59f;
  cursor: pointer;
}

@media screen and (max-width:375px){
.text-group{
  margin: -25% auto 0 6%;
  }
.content-textarea{
  padding: 10px 10px;
}
}
</style>